// The widths of the two kinds of page, from the foundation shared with notesfrom: a gallery (a family, a book, a
// recipe) spreads up to 75rem, and a reading or form page keeps notesfrom's 47.5rem measure. Margins grow with
// the screen.
export const page = 'mx-auto w-full max-w-(--gallery) px-5 sm:px-8 lg:px-12'
export const column = 'mx-auto w-full max-w-(--measure) px-5 sm:px-8'

// Pebble and Initial now live with the other paper pieces; they're still reachable from here for code that imports
// them from layout.
export { Initial, Pebble } from './paper'
